<script lang="ts" setup>
import AUApi from "@/api";
import { ref, onMounted } from "vue";
import { getDisplayValue } from "@/DataHelper";
import { showSnackbar } from "@/UIHelper";

const props = defineProps<{
  query?: string;
  text?: string;
  text1?: string;
  textQuery?: string;
  textKennung?: string;
  text1Kennung?: string;
  icon?: string;
  textIcon?: string;
  aic?: number;
  zeitbereich?: APIZeitbereich | null;
  width?: string;
}>();
let showLoading = ref<boolean>(false);
let initalized = ref<boolean>(false);
let textValue = ref("");
let textValue1 = ref("");

let dialog = ref<boolean>(false);
onMounted(() => {
  try {
    showLoading.value = true;
    if (props.textQuery && props.textQuery.trim() !== "") {
      const vecStamm: any[] = [];
      AUApi.Current.getQuery(
        props.textQuery,
        dataLoaded,
        props.aic,
        props.zeitbereich,
        0,
        false,
        false,
        "",
        0,
        vecStamm
      );
    }
  } catch (e: any) {
    console.error("mounterror: " + e, e?.stack);
  }
});

function dataLoaded(resp: any) {
  if (resp.data.error) {
    showSnackbar({
      text: "Error: " + resp.data.error,
      color: "error",
    });
    return;
  }

  const column = resp.data.columns.find((c: any) => c.kennung === props.textKennung);
  const data = resp.data.data;
  if (data.length > 0) {
    const value = resp.data.data[0][column.name];
    if (value) {
      textValue = getDisplayValue(value, column);
    } else {
      textValue.value = "-";
    }
    if (props.text1Kennung) {
      const column1 = resp.data.columns.find(
        (c: any) => c.kennung === props.text1Kennung
      );
      const value1 = resp.data.data[0][column1.name];
      if (value1) {
        textValue1 = getDisplayValue(value1, column1);
      } else {
        textValue1.value = "-";
      }
    }
  }
  showLoading.value = false;
}
// function back() {
//   // $emit("back");
// }
</script>
<template>
  <v-sheet
    class="ma-0 pa-2 dvhBackground lighten-2 vcard-dialog-sheet"
    :loading="showLoading"
    :style="{ maxWidth: width ?? '450px', width: '100%' }"
    variant="tonal"
    style="color: white"
    min-height="52px"
  >
    <v-card-text style="padding: 0; padding-left: 1rem; padding-top: 0.5rem">
      <span>
        {{ text }}: &emsp;
        {{ textValue }}
      </span>
      <span v-if="text1" class="pl-2">
        {{ text1 }}: &emsp;
        {{ textValue1 }}
      </span>
    </v-card-text>
    <!-- <v-card-actions>
      <v-btn
        v-if="icon"
        variant="text"
        size="small"
        color="primary"
        id="Vcard"
        @click="dialog = true"
        :icon="icon"
        :text="textIcon"
      >
      </v-btn>
    </v-card-actions>
    <v-dialog
      v-if="dialog"
      id="VCard"
      v-model="dialog"
      persistent
      fullscreen
      hide-overlay
      transition="dialog-bottom-transition"
      scrollable
    >

    <v-card-actions>
          <CommonBaseButtons
            :deleteVisible="false"
            :createVisible="false"
            :saveVisible="false"
            @back="dialog = false"
            @refresh="onRefresh"
          ></CommonBaseButtons>
        </v-card-actions> 


    </v-dialog> -->
  </v-sheet>
</template>
<style scoped>
.cardText {
  margin-bottom: 5px;
  text-align: left;
}
.v-card-text {
  font-size: 15px !important;
}
</style>
